























import { Component } from 'vue-property-decorator';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import { Funcionalidades } from '@/config/funcionalidades';
import {
  PermisoAccion,
  codigoAccionesMenuItem as Acciones,
} from '@/views/base/VariablesPermisos';

import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ColDef,
} from 'ag-grid-community';

import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import moment from 'moment';
import BajasCobranzaFilters from './BajasCobranzaFilters.vue';
import BajasCobranzaVerDetalle from './gridActions/BajasCobranzaVerDetalle.vue';
import BajasCobranzaActions from './BajasCobranzaActions.vue';
import { fetchMS } from './fetchMS';
import { ParamApi } from './models/BajasCobranza.models';
import { actionsEvent } from '@/setup';
import BajasCobranzaEditar from '@/pantallas/Conecta/BajasCobranza/gridActions/BajasCobranzaEditar.vue';

@Component({
  components: {
    MantenedorGridSinCodigo,
    BajasCobranzaFilters,
    BajasCobranzaActions,
    BajasCobranzaVerDetalle,
    BajasCobranzaEditar,
  },
})
export default class BajasCobranza extends ComponenteBase {
  funcionalidad: Funcionalidades = Funcionalidades.BajasCobranza;

  gridOptions: GridOptions = null;
  gridEvent: GridReadyEvent = null;
  gridApi: GridApi = null;
  columnDefs: ColDef[] = [];
  serverSide: any = [];
  data: any = {};
  dataList: any[] = [];
  paramApi: ParamApi = {
    start_date: moment().subtract(1, 'month'),
    end_date: moment(),
    typeDate: {
      id_date: 1,
      name_date: 'Fecha Creación',
    },
  };
  statusFinished: boolean = true;

  dialogVerDetalle: boolean = false;
  dialogEditar: boolean = false;

  readonly accionesTotales: PermisoAccion[] = [
    {
      accionCodigo: Acciones.accionEditar,
      visible: false,
    },
  ];

  actions() {
    actionsEvent.onVerDetalle(this.handleVerDetalle);
    actionsEvent.onEditar(this.handleEditar);
  }

  constructor() {
    super();
    // Remover las acciones para evitar bucles de notificaciones
    actionsEvent.removeListeners();
    // Volver a llamarlas
    this.actions();

    this.columnDefs = this.colsGrid();

    this.gridOptions = {
      columnDefs: this.columnDefs,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      overlayNoRowsTemplate: 'No hay datos disponibles para mostrar',
      onGridReady: this.handleMainGridReady,
      rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
    };
  }

  handleVerDetalle(params: any) {
    this.data = { ...params.data };
    this.dialogVerDetalle = true;
  }

  handleEditar(params: any) {
    this.data = { ...params.data };
    this.statusFinished =
      Number(params.data.id_estado_conecta) === 3 ? true : false;
    this.dialogEditar = true;
  }
  private colsGrid(): ColDef[] {
    const cols = [
      { field: 'Nombre Baja Cobranza', id: 'nombre_baja_cobranza' },
      { field: 'Fecha Creación', id: 'fecha_creacion_format' },
      { field: 'Cliente', id: 'cliente' },
      { field: 'Cantidad EPC', id: 'cantidad_epc' },
      { field: 'Descripción', id: 'descripcion' },
      { field: 'Observaciones', id: 'observaciones' },
      { field: 'Estado Conecta', id: 'estado_conecta' },
      { field: 'Estado CRM', id: 'estado_crm' },
      { field: 'Razón Estado', id: 'razon_estado' },
      { field: 'Nombre Tramo Baja Temporal', id: 'nombre_tramo_baja_temporal' },
      {
        field: 'Nombre Tramo Baja Definitiva',
        id: 'nombre_tramo_baja_definitiva',
      },
      {
        field: 'Fecha Ingreso Baja Temporal',
        id: 'fecha_ingreso_baja_temporal',
      },
      {
        field: 'Fecha Ingreso Baja Definitiva',
        id: 'fecha_ingreso_baja_definitiva',
      },
      { field: 'Fecha Recuperación Cliente', id: 'fecha_recuperacion_cliente' },
      { field: 'Glosa CRM', id: 'glosa_api_crm' },
    ];

    return cols.map(col => {
      let cellRenderer = null;

      if (col.id === 'estado_conecta') {
        cellRenderer = { cellRenderer: this.handleEstadoConecta };
      }

      return {
        headerName: col.field,
        field: col.id,
        cellStyle: { textAlign: 'left' },
        resizable: true,
        minWidth: 200,
        width: 200,
        ...cellRenderer,
      };
    });
  }

  handleEstadoConecta(params: any) {
    if ('data' in params) {
      return params.data.estado_conecta || 'Pendiente';
    }
    return '';
  }

  handleMainGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.gridEvent = event;
    const self = this;
    this.serverSide = {
      async getRows(event: any): Promise<void> {
        event.request.paginationSize = self.gridOptions.cacheBlockSize;
        const body = {
          start_date: self.paramApi.start_date,
          end_date: self.paramApi.end_date,
          rut_cliente:
            (self.paramApi.cliente && self.paramApi.cliente.rut_cliente) || '',
          estado_conecta: self.paramApi.estado_conecta
            ? self.paramApi.estado_conecta.id_estado_conecta
            : '',
          id_date: self.paramApi.typeDate
            ? Number(self.paramApi.typeDate.id_date)
            : '',
          startRow: event.request.startRow,
          endRow: event.request.endRow,
          baja_temporal: self.paramApi.baja_temporal
            ? self.paramApi.baja_temporal.id_baja_temporal
            : '',
          baja_definitiva: self.paramApi.baja_definitiva
            ? self.paramApi.baja_definitiva.id_baja_definitiva
            : '',
          razon_estado: self.paramApi.razon_estado
            ? self.paramApi.razon_estado.razon
            : '',
          nombre_baja: self.paramApi.bajaCobranza
            ? self.paramApi.bajaCobranza
            : '',
        };
        try {
          const response = await fetchMS({ body });
          const {
            MENSAJE_RESPUESTA,
            CODIGO_RESPUESTA,
            LISTA,
            TOTAL,
          } = response.data;

          if (Number(CODIGO_RESPUESTA) !== 1) {
            event.successCallback([], 0);
            self.gridApi.showNoRowsOverlay();
            MENSAJE_RESPUESTA !== 'SIN_DATA' &&
              self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
            self.dataList = [];
            return;
          }
          self.dataList = [...LISTA];
          event.successCallback(LISTA, TOTAL);
        } catch (error) {
          self.$snotify.error(
            'Ha ocurrido un error inesperado, por favor reintente un poco más tarde',
            { timeout: 3500 }
          );
        }
      },
    };
    this.reloadGrid();
  }

  reloadGrid() {
    setTimeout(() => {
      this.gridApi.setServerSideDatasource(this.serverSide);
      this.gridApi.setDomLayout('autoHeight');
    }, 0);
  }

  handleFilters(params: ParamApi = {}) {
    this.paramApi = { ...params };
    this.reloadGrid();
  }

  handleCloseModal(clean: boolean = false) {
    this.dialogVerDetalle = false;
    this.dialogEditar = false;
    this.loadingService.hideLoading();
    this.data = {};
    clean && this.reloadGrid();
  }
}
